var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 2,
    viewBox: "0 0 12 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.416 1.83268C2.80024 1.83268 9.19846 1.83268 0.582682 1.83268C0.352564 1.83268 0.166016 1.64613 0.166016 1.41602V0.582682C0.166016 0.352564 0.352564 0.166016 0.582682 0.166016C9.19846 0.166016 2.80024 0.166016 11.416 0.166016C11.6461 0.166016 11.8327 0.352564 11.8327 0.582682V1.41602C11.8327 1.64613 11.6461 1.83268 11.416 1.83268Z",
    fill: "#567AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minusIcon.9a663d5a.svg";
export { ForwardRef as ReactComponent };